export default __webpack_public_path__ + "static/media/back3.66ff6882.png";